var $ = require('jQuery');
var Vue = require('vue');
var Webhooks = require('./Webhooks.vue').default;
var Marker = require('../../lib/markers/marker.js');
var Revealer = require('../../lib/revealer.js');
var Deletism = require('../../lib/markers/deletism.js');
var Columnator = require('../../lib/columnator.js');
var IndexView = require('../../lib/index-view.js');
const SavedViewsShortcutsBar = require("./../search/components/SavedViewsShortcutsBar").default;
const store = require('@/lib/store').default;

module.exports = function() {
    const webhooks = new Vue({
        el: '#webhooks',
        components: {
            'webhooks': Webhooks
        },
        store
    });

    $(document).one('pjax:end', () => {
        webhooks.$destroy();
    });
    var marker = new Marker('webhooks');
    new Revealer();
    new Deletism(marker);
    new IndexView();
    new Columnator();
};
